import marked from 'marked'
import userAgent from '@/libs/user-agent'

const renderer = new marked.Renderer()

const appWhitelistedVideoDomains = ['engineering.com', 'youtube.com', 'youtu.be', 'vzaar.com', 'kickstarter.com', 'vimeo.com', 'brightcove.net', 'livestream.com']

const imageAlignModifier = ['image-left', 'image-right', 'image-center', 'image-inset-left', 'image-inset-right']
const imageClassModifier = ['image-inline']

const captionRegex = new RegExp(/^<em>.*<\/em>$/)
const imageAltRegex = new RegExp(/^<img[^>]*alt="([^"]*).*\/>/)

// open links in a new window
renderer.link = (href, title, text) => {
  if (text === 'video-embed') {
    return renderer.video(href)
  }

  if (text === 'sub-tag') {
    return renderer.subscript(href)
  }

  if (text === 'sup-tag') {
    return renderer.superscript(href)
  }

  const target = '_blank'
  title = title || ''
  return `<a target="${target}" href="${href}" title="${title}">${text}</a>`
}

// run images through our proxy
renderer.image = (href, title, text) => {
  title = title || ''
  text = text || ''
  let extra = ''

  if (imageClassModifier.indexOf(text) >= 0) {
    extra = `class="${text}"`
  }

  return `<img src="${href}" title="${title}" alt="${text}" ${extra} />`
}

renderer.video = (href) => {
  if (href.indexOf('//') < 0) {
    href = `https://${href}`
  } else if (href.length > 6 && href.substring(0, 6) !== 'https:') {
    href = href.replace(/^.*:?\/\//, 'https://')
  }

  if (userAgent.isApp() || userAgent) {
    const parts = href.split('/')
    const host = parts.length >= 3 ? parts[2] : ''

    if (!isVideoWhitelisted(host)) {
      const embed = `${process.env.WEB_ROOT}/embed?url=${encodeURIComponent(href)}&type=video`
      return `<p class="video-link"><a class="button is-primary is-outlined" target="_blank" href="${embed}"><span class="icon"><i class="fal fa-play-circle"></i></span><span>Play (source: ${host})</span></a></p>`
    }
  }

  return `<p class="video"><iframe src="${href}" frameborder="0" width="100%" height="100%" allowFullScreen="true"></iframe></p>`
}

renderer.subscript = (content) => {
  return `<sub>${content}</sub>`
}

renderer.superscript = (content) => {
  return `<sup>${content}</sup>`
}

marked.setOptions({
  breaks: true,
  renderer: renderer
})

const isVideoWhitelisted = function (host) {
  for (let i = 0; i < appWhitelistedVideoDomains.length; i++) {
    if (host.indexOf(appWhitelistedVideoDomains[i]) >= 0) {
      return true
    }
  }

  return false
}

renderer.paragraph = (content) => {
  let extra = ''

  if (captionRegex.test(content)) {
    extra = 'class="caption"'
  } else {
    const match = imageAltRegex.exec(content)
    if (match && match.length >= 1) {
      const imageAlt = match[1]
      if (imageAlignModifier.indexOf(imageAlt) >= 0) {
        extra = `class="${imageAlt}"`
      }
    }
  }

  return `<p ${extra}>${content}</p>`
}

export default marked
